<template>
  <div>
    <div
      class="page-header page-header-bg"
      style="background-image: url('assets/images/banners/banner-top.jpg')"
    >
      <div class="container">
        <h1>{{ translations.brands }}</h1>
      </div>
      <!-- End .container -->
    </div>
    <!-- End .page-header -->
    <div class="features-section">
      <div class="container">
        <div class="row">
          <div class="col-md-6" v-for="brand in highlightedBrands" :key="brand.brandId">
            <div class="feature-box feature-brand wrapper-btn">
              <router-link :to="{ name: 'Brand',
                params: { id: brand.brandId, title: brand.brandTitle.replace(/\s+/g, '-') } }">
                <img :src="`${baseUrl}${brand.brandOriginalImageUrl}`" alt="logo" />
              </router-link>
            </div>
            <!-- End .feature-box -->
          </div>
          <!-- End .col-md-6 -->
        </div>
        <!-- End .row -->
      </div>
      <!-- End .container -->
    </div>
    <!-- End .features-section -->

    <div class="features-section">
      <div class="container">
        <div class="row">
          <div class="col-md-4 col-xs-6" v-for="brand in restBrands" :key="brand.brandId">
            <div class="feature-box other-brand wrapper-btn">
              <router-link :to="{ name: 'Brand',
                params: { id: brand.brandId, title: brand.brandTitle.replace(/\s+/g, '-') } }">
                <img :src="`${baseUrl}${brand.brandOriginalImageUrl}`" alt="logo" />
              </router-link>
            </div>
            <!-- End .feature-box -->
          </div>
          <!-- End .col-md-4 -->
        </div>
        <!-- End .row -->
      </div>
      <!-- End .container -->
    </div>
    <!-- End .features-section -->
  </div>
</template>

<script>
import config from '@/config';
import { translations } from '@/mixins';

export default {
  name: 'Brands',
  mixins: [translations],
  computed: {
    baseUrl() {
      return config.baseUrl;
    },
    brands() {
      return this.$store.getters.getTopBrands;
    },
    highlightedBrands() {
      return this.brands.slice(0, 2);
    },
    restBrands() {
      return this.brands.slice(2, this.brands.length);
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.$store.dispatch('getTopBrands');
  },
};
</script>
